import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";

import {
  periodos,
  getCertificado,
  rteivaProveedor,
  rteivarangeProveedor,
} from "../../slices/certificaciones/certificadosThunks";
import { CardCertIva } from "../Cards/CardCertIva";
import LoadingPortal from '../loadings/LoadingPortal';
import { toast } from "react-toastify";

export const Rteiva = () => {
  const dispatch = useDispatch();
  const { yearsDB, periodosDB, rteivaDB, loading } = useSelector(
    (state) => state.certificados
  );

  const [selectedVigencia, setSelectedVigencia] = useState(null);
  const [selectedPeriodo, setSelectedPeriodo] = useState(null);
      
  const d = new Date();
  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    setValue
  } = useForm();

  const onSubmit = (value) => {
    if(value.vigencia === "" && value.periodo === "" ) {
        toast.error("Debe seleccionar un valor para realizar la busqueda");
    } else{
      const data = {
        vigencia: value.vigencia,
        periodo: value.periodo,
        type_cert: 1,
        nit: value.nit
      };
      dispatch(rteivarangeProveedor(data));
    }
  };
  const getRteiva = async () => {
    dispatch(rteivaProveedor({ vigencia: d.getFullYear() - 1 }));
  };
  const getPeriodos = async () => {
    dispatch(periodos({ periodicity: "B" }));
  };

  const onClearForm = () => {
    getRteiva();
    setSelectedVigencia(null);
    setValue("vigencia", null);
    setSelectedPeriodo(null);
    setValue("periodo", null);
  };

  const getCert = async (value) => {
    let info = value;
    const data = {
      vigencia: info.vigencia,
      type_cert: 1,
      periodo: info.id_period,
      ciudad: 1,
      bimestre: info.period.split(" - ")[0]
    };
    dispatch(getCertificado(data));
  };

  useEffect(() => {
    getRteiva();
    getPeriodos();
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <div className="mt-2">
        <form
          className="row col-12 col-md-12"
          onSubmit={handleSubmit(onSubmit)}
        >
          <input type="hidden" {...register("type_cert")} value="2" />
          <div className="col-12 col-md-3">
            <label>Vigencia</label>
            {yearsDB && (
              <Controller
                name="vigencia"
                defaultValue={""}
                control={control}
                render={({ field, value, name }) => (
                  <Select
                    label="Vigencia"
                    name={field.name}
                    options={
                      yearsDB
                        ? yearsDB.map((option, idx) => ({
                            value: option,
                            label: option,
                          }))
                        : ""
                    }
                    value={selectedVigencia}
                    onChange={(val) =>{
                      setSelectedVigencia(val);
                      field.onChange(val.value)
                    }}
                  />
                )}
              />
            )}
            <p>{errors.vigencia?.message}</p>
          </div>
          <div className="col-12 col-md-3">
            <label>Periodo</label>
            {periodosDB && (
              <Controller
                name="periodo"
                defaultValue={""}
                control={control}
                render={({ field, value, name }) => (
                  <Select
                    label="Periodo"
                    name={field.name}
                    defaultValue={"Select"}
                    options={
                      periodosDB
                        ? periodosDB.map((option) => ({
                            value: option.id_period,
                            label: option.desc_period,
                          }))
                        : ""
                    }
                    value={selectedPeriodo}
                    onChange={(val) =>{
                      setSelectedPeriodo(val);
                      field.onChange(val.value)
                    }}
                  />
                )}
              />
            )}
            <p>{errors.periodo?.message}</p>
          </div>
          <div className="col-12 col-md-2 pt-4 mt-2">
            <button
              type="submit"
              className="btn btn-danger btn-block font-weight-bold"
            >
              Buscar
            </button>
          </div>
          <div className="col-12 col-md-2  pt-4 mt-2">
            <button
              type="button"
              className="btn btn-secondary btn-block font-weight-bold"
              onClick={onClearForm}
            >
              Limpiar
            </button>
          </div>
        </form>
      </div>
      <div className="mt-4 px-2">
        <div className="row">
          {loading ? (
            <LoadingPortal isOpen={loading} />
          ) : (
            <>
              {rteivaDB.length > 0 ? (
                rteivaDB.map((r, index) => (
                  <div
                    className="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-4"
                    key={index}
                  >
                    <CardCertIva
                      titulo="CERTIFICADO DE RETENCIONES A TITULO DEL IMPUESTO SOBRE LAS VENTAS"
                      item={r}
                      getCertificado={getCert}
                    />
                  </div>
                ))
              ) : (
                <p>No hay datos</p>
              )}
            </>
          ) }
        </div>
      </div>
    </>
  );
};
